module.exports = __webpack_public_path__ + "static/media/24.aac8af2e.gif";